/**
 * ADD CONTACT CARD - Carte pour ajouter un membre/contact
 */

import { Plus } from 'lucide-react';
import { Card } from '../ui/card';

interface AddContactCardProps {
  onClick: () => void;
  /** Label optionnel à afficher à côté de l'icône */
  label?: string;
}

export function AddContactCard({ onClick, label }: AddContactCardProps) {
  return (
    <Card className="p-1">
      <button
        onClick={onClick}
        className="w-full h-[58px] flex items-center justify-center gap-2 border-2 border-dashed border-zinc-300 rounded-md hover:border-zinc-400 hover:bg-zinc-50 transition-colors"
      >
        <Plus className="h-5 w-5 text-zinc-400" />
        {label && <span className="text-sm text-zinc-500">{label}</span>}
      </button>
    </Card>
  );
}
